import { render, staticRenderFns } from "./ApplyLifeLicense.vue?vue&type=template&id=630ddc0a&scoped=true"
import script from "./ApplyLifeLicense.vue?vue&type=script&lang=js"
export * from "./ApplyLifeLicense.vue?vue&type=script&lang=js"
import style0 from "./ApplyLifeLicense.vue?vue&type=style&index=0&id=630ddc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630ddc0a",
  null
  
)

export default component.exports